import {
	LOGGED,
	MODAL_AUTH_CLOSED,
	SIGN_UP_SUCCESS,
	SIGN_UP_SOCIAL_SUCCESS,
	SIGN_UP_SOCIAL_ERROR,
	QUALIFIED_SUCCESS,
	QUALIFIED_ERROR,
	SUPPORT_CREDENTIALS_ERROR
} from '@/redux/actions/auth.actions'
import { LOGIN_TIMEOUT } from '@/redux/actions/auth.actions'
import { SIGN_UP_DESCRIPTION_BY_ID } from '@/constants/constants'

const loggedSuccess = (_, __, nextState) => {
	const account = nextState.auth.account
	return {
		event: 'eventoGA',
		eventCat: 'login successful',
		eventAct: account.registerType,
		eventLbl: account.roles && account.roles[0]
	}
}

const modalAuthClosed = () => {
	return {
		event: 'eventoGA',
		eventCat: 'login error',
		eventAct: 'modal closed',
		eventLbl: ''
	}
}

const loginTimeout = () => {
	return {
		event: 'eventoGA',
		eventCat: 'login error',
		eventAct: 'login timeout',
		eventLbl: ''
	}
}

const signUpSuccess = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Registration_Web-user',
		eventAct: SIGN_UP_DESCRIPTION_BY_ID[action.payload.registerType] || '',
		eventLbl: ''
	}
}

const signUpSocialSuccess = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Registration_Web-user',
		eventAct: action.payload.message,
		eventLbl: ''
	}
}

const signUpSocialError = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Registration_Web-user error',
		eventAct: action.payload.message,
		eventLbl: ''
	}
}

const qualifiedSuccess = (_, __, nextState) => {
	const userType = nextState.auth.account.userType
	return {
		event: 'eventoGA',
		eventCat: 'New Qualified User',
		eventAct: userType === 'PROFESSIONAL' ? nextState.auth.account.company?.companyType.description : '',
		eventLbl: userType || ''
	}
}

const qualifiedError = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'New Qualified User Error',
		eventAct: action.payload.message,
		eventLbl: ''
	}
}

const supportCredentialsError = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'login error',
		eventAct: action.payload.message,
		eventLbl: ''
	}
}

export default {
	[LOGGED]: loggedSuccess,
	[SIGN_UP_SUCCESS]: signUpSuccess,
	[SIGN_UP_SOCIAL_SUCCESS]: signUpSocialSuccess,
	[SIGN_UP_SOCIAL_ERROR]: signUpSocialError,
	[QUALIFIED_SUCCESS]: qualifiedSuccess,
	[QUALIFIED_ERROR]: qualifiedError,
	[MODAL_AUTH_CLOSED]: modalAuthClosed,
	[LOGIN_TIMEOUT]: loginTimeout,
	[SUPPORT_CREDENTIALS_ERROR]: supportCredentialsError
}
